import { z } from 'zod';
import { InspectionCornSchema, NoteCornSchema } from '../base.js';
import { NoteSchema } from '../entities/note.js';
import { InspectionsServiceEventBaseSchema, inspectionsServiceEventType } from './service.js';
export const NoteCreatedEventSchema = InspectionsServiceEventBaseSchema.merge(z.object({
    type: inspectionsServiceEventType('note', 'created'),
    note: NoteSchema,
}));
export const NoteUpdatedEventSchema = InspectionsServiceEventBaseSchema.merge(z.object({
    type: inspectionsServiceEventType('note', 'updated'),
    note: NoteSchema,
}));
export const NoteDeletedEventSchema = InspectionsServiceEventBaseSchema.merge(z.object({
    type: inspectionsServiceEventType('note', 'deleted'),
    note: z.object({
        noteId: NoteCornSchema,
        inspectionId: InspectionCornSchema,
    }),
}));
